module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('permit-to-work', {
    attrs: {
      "site-id": _vm.site.id
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-76341246"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sites/permits/SitePermitToWork.vue
// module id = 1567
// module chunks = 0